// import env from "configs";
// import { adminApi } from "./api";
// import { SCHOOLS_TAG, USERS_TAG } from "./CONSTANTS";

// export const schoolsApi = adminApi.injectEndpoints({
//   endpoints: (builder) => ({
//     fetchSchools: builder.query<any[], void>({
//       query: () => {
//         // Get token from localStorage (adjust the key name if needed)
//         const token =
//           localStorage.getItem("accessToken") ??
//           localStorage.getItem("authToken") ??
//           localStorage.getItem("accessToken");

//         console.log("=== SCHOOLS API REQUEST ===");
//         console.log("Token:", token ? "Token found" : "No token found");
//         console.log("URL:", `${env.API_BASE_URL}/schools`);
//         console.log("=== END REQUEST ===");

//         return {
//           url: `${env.API_BASE_URL}/schools`,
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         };
//       },
//       transformResponse: (response: any) => {
//         console.log("=== SCHOOLS API RESPONSE ===");
//         console.log("Full Response:", response);
//         console.log("Response Type:", typeof response);
//         console.log("Is Array:", Array.isArray(response));

//         if (response?.data) {
//           console.log("Response.data:", response.data);
//           console.log("Response.data Type:", typeof response.data);
//           console.log("Response.data Is Array:", Array.isArray(response.data));
//         }

//         console.log("=== END SCHOOLS API RESPONSE ===");
//         return response.DATA.programs;
//       },
//       providesTags: [SCHOOLS_TAG, USERS_TAG]
//     }),
//     createSchool: builder.mutation<any, any>({
//       query: (school) => ({
//         url: `${env.API_BASE_URL}/post/schools`,
//         method: "POST",
//         body: school
//       })
//     }),
//     updateSchool: builder.mutation<any, any>({
//       query: (school) => ({
//         url: `${env.API_BASE_URL}/schools/:id`,
//         method: "PATCH",
//         body: school
//       })
//     })
//   })
// });

// export const { useFetchSchoolsQuery } = schoolsApi;
import env from "configs";
import { adminApi } from "./api";
import { SCHOOLS_TAG, USERS_TAG } from "./CONSTANTS";

export const schoolsApi = adminApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSchools: builder.query<any[], void>({
      query: () => {
        // Get token from localStorage (adjust the key name if needed)
        const token =
          localStorage.getItem("accessToken") ??
          localStorage.getItem("authToken") ??
          localStorage.getItem("accessToken");

        console.log("=== SCHOOLS API REQUEST ===");
        console.log("Token:", token ? "Token found" : "No token found");
        console.log("URL:", `${env.API_BASE_URL}/schools`);
        console.log("=== END REQUEST ===");

        return {
          url: `${env.API_BASE_URL}/schools`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`
          }
        };
      },
      transformResponse: (response: any) => {
        console.log("=== SCHOOLS API RESPONSE ===");
        console.log("Full Response:", response);
        console.log("Response Type:", typeof response);
        console.log("Is Array:", Array.isArray(response));

        if (response?.data) {
          console.log("Response.data:", response.data);
          console.log("Response.data Type:", typeof response.data);
          console.log("Response.data Is Array:", Array.isArray(response.data));
        }

        console.log("=== END SCHOOLS API RESPONSE ===");
        return response.DATA.programs;
      },
      providesTags: [SCHOOLS_TAG, USERS_TAG]
    }),

    createSchool: builder.mutation<any, any>({
      query: (school) => {
        // Get token from localStorage
        const token =
          localStorage.getItem("accessToken") ??
          localStorage.getItem("authToken");

        console.log("=== CREATE SCHOOL REQUEST ===");
        console.log("Token:", token ? "Token found" : "No token found");
        console.log("URL:", `${env.API_BASE_URL}/post/schools`);
        console.log("Payload:", school);
        console.log("=== END CREATE REQUEST ===");

        return {
          url: `${env.API_BASE_URL}/post/schools`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: school
        };
      },
      // Invalidate the schools cache after creating a new school
      invalidatesTags: [SCHOOLS_TAG]
    }),

    updateSchool: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => {
        // Get token from localStorage
        const token =
          localStorage.getItem("accessToken") ??
          localStorage.getItem("authToken");

        console.log("=== UPDATE SCHOOL REQUEST ===");
        console.log("Token:", token ? "Token found" : "No token found");
        console.log("School ID:", id);
        console.log("URL:", `${env.API_BASE_URL}/schools/${id}`);
        console.log("Payload:", data);
        console.log("=== END UPDATE REQUEST ===");

        return {
          url: `${env.API_BASE_URL}/schools/${id}`,
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: data
        };
      },
      // Invalidate the schools cache after updating a school
      invalidatesTags: [SCHOOLS_TAG]
    })
  })
});

export const { 
  useFetchSchoolsQuery, 
  useCreateSchoolMutation, 
  useUpdateSchoolMutation 
} = schoolsApi;
